import React from 'react'
import { useSelector } from 'react-redux'
import Map from 'components/Map/Map'
import { useDebouncedCallback } from 'use-debounce'
import {
  StyledAddressButtonIndex,
  StyledAddressButtonMaps,
  StyledAddressButtonReport,
  StyledAddressButtonValue,
  StyledAddressButtonsContainer,
  StyledAddressPanel,
  StyledProductsButtonContainer,
} from './AddAddress.styles'
import getCountriesCode from 'common/utils/getCountrieCode'
import { selectCustomerConfiguration } from 'slices/customerConfigurationSlice'
import { useAppDispatch } from 'store/hooks'
import { selectAddressFormData, setFormField, setProductName } from 'slices/addressFormSlice'
import { AddressGeocoded } from 'types/AddressGeocoded'
import { BuildingType, ObjectType } from 'types/ApiResponse'
import Button from 'components/Button/Button'
import SprengnetterAppsReport from 'assets/images/icons/SprengnetterAppsReport.png'
import SprengnetterAppsIndex from 'assets/images/icons/SprengnetterAppsIndex.png'
import SprengnetterAppsMaps from 'assets/images/icons/SprengnetterAppsMaps1x.png'
import SprengnetterAppsValue from 'assets/images/icons/SprengnetterAppsValue.png'
import { findInArray } from 'common/utils/generic'
import { useTranslation } from 'react-i18next'

const AddAddress = (props: any) => {
  const { setCurrentTab } = props
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const customerConfig = useSelector(selectCustomerConfiguration)
  const addressFormData = useSelector(selectAddressFormData)
  const countries = getCountriesCode(customerConfig.name)
  const priority =
    (customerConfig?.configuration?.priority &&
      JSON.parse(customerConfig?.configuration?.priority)) ||
    {}
  const indicesProduct = findInArray(customerConfig?.products, 'name', 'indices')
  const reportProduct = findInArray(customerConfig?.products, 'name', 'report')
  const mapsProduct = findInArray(customerConfig?.products, 'name', 'maps')
  const valueProduct = findInArray(customerConfig?.products, 'name', 'value')

  const onChange = useDebouncedCallback((address: AddressGeocoded) => {
    dispatch(setFormField({ key: 'lat', value: address.lat }))
    dispatch(setFormField({ key: 'lng', value: address.lng }))
    dispatch(setFormField({ key: 'houseNumber', value: address.houseNumber }))
    dispatch(setFormField({ key: 'street', value: address.street }))
    dispatch(setFormField({ key: 'zip', value: address.zip }))
    dispatch(setFormField({ key: 'town', value: address.town }))
    dispatch(setFormField({ key: 'nation', value: address.nation }))
    dispatch(setFormField({ key: 'propertyDetails.objectType', value: ObjectType.HOUSE }))
    dispatch(
      setFormField({ key: 'propertyDetails.buildingType', value: BuildingType.SINGLE_FAMILY_HOUSE })
    )
  }, 500)

  const onButtonClick = (productName: string) => {
    if (!addressFormData?.addressData?.houseNumber) {
      return
    }
    dispatch(setProductName(productName))
    setCurrentTab((tab) => tab + 1)
  }

  return (
    <>
      <StyledAddressPanel>
        <Map
          latitude={customerConfig.mapOptions.lat || 50.548187591116715}
          longitude={customerConfig.mapOptions.lng || 7.131986305434703}
          countries={countries}
          onChange={onChange}
        />
      </StyledAddressPanel>
      {addressFormData?.addressData?.houseNumber?.length > 0 && (
        <StyledProductsButtonContainer>
          <p>{t('newAddressModal.addressTab.options')}</p>
          <StyledAddressButtonsContainer>
            {indicesProduct?.active && (
              <StyledAddressButtonIndex order={priority[indicesProduct?.id] || 0}>
                <img src={SprengnetterAppsIndex} alt={SprengnetterAppsIndex} />
                <Button kind="secondary" onClick={() => onButtonClick('index')}>
                  Index
                </Button>
              </StyledAddressButtonIndex>
            )}
            {reportProduct?.active && (
              <StyledAddressButtonReport order={priority[reportProduct?.id] || 0}>
                <img src={SprengnetterAppsReport} alt={SprengnetterAppsReport} />
                <Button kind="gray" onClick={() => onButtonClick('report')}>
                  Report
                </Button>
              </StyledAddressButtonReport>
            )}
            {mapsProduct?.active && (
              <StyledAddressButtonMaps order={priority[mapsProduct?.id] || 0}>
                <img src={SprengnetterAppsMaps} alt={SprengnetterAppsMaps} />
                <Button
                  kind="orange"
                  onClick={() => {
                    onButtonClick('map')
                  }}
                >
                  Maps
                </Button>
              </StyledAddressButtonMaps>
            )}
            {valueProduct?.active && (
              <StyledAddressButtonValue order={priority[valueProduct?.id] || 0}>
                <img src={SprengnetterAppsValue} alt={SprengnetterAppsValue} />
                <Button kind="primary" onClick={() => onButtonClick('value')}>
                  Value
                </Button>
              </StyledAddressButtonValue>
            )}
          </StyledAddressButtonsContainer>
        </StyledProductsButtonContainer>
      )}
    </>
  )
}

export default AddAddress
